import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { IconToggle } from 'components/atoms';
import { useSpring, animated } from 'react-spring';

const NavToggle = ({
  isActive: isActiveDefault,
  onClick,
  showIcon,
  isOpen,
}) => {
  const [isActive, setIsActive] = useState(isActiveDefault);
  const opacityAnim = useSpring({ opacity: showIcon ? 1 : 0 });

  return (
    <Wrapper onClick={onClick} role="button">
      <Wrapper.Relative
        onMouseEnter={() => setIsActive(true)}
        onMouseLeave={() => setIsActive(false)}
      >
        <IconToggleWrapper style={opacityAnim}>
          <IconToggle
            isOpen={isOpen}
            isActive={isActive}
            icon={{ closed: 'nav' }}
          />
        </IconToggleWrapper>
        <Seperator isActive={isActive} />
      </Wrapper.Relative>
    </Wrapper>
  );
};

const IconToggleWrapper = styled(animated.div)`
  z-index: ${props => props.theme.values.zIndex.m};
  margin-top: 50vh;
`;

NavToggle.propTypes = {
  isActive: PropTypes.bool,
  showIcon: PropTypes.bool,
  onClick: PropTypes.func,
  isOpen: PropTypes.bool,
};

NavToggle.defaultProps = {
  isActive: false,
  showIcon: true,
  onClick: () => {},
  isOpen: true,
};

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 100%;
  transform: translateX(-50%);
  height: 100%;
  button {
    z-index: ${props => props.theme.values.zIndex.s};
  }
  cursor: ew-resize;
`;

Wrapper.Relative = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  top: ;
`;

const Seperator = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 1px;
  height: 100%;
  transition: background-color 0.5s ease-out;
  background-color: ${({ theme, isActive }) => (isActive
    ? theme.colors.bgPrimary
    : theme.components.navActions.backgroundColor)};
`;

export default NavToggle;
